<template>
    <FilterLayout :advanceOption="false">
      <section data-test="filter-user-group-section">
        <div class="mt-2">
          <label class="from-label text-xxs text-gray-600" for="osm-select">กลุ่มผู้ใช้งาน</label>
          <v-select
            data-test="user-group-select"
            id="user-group-select"
            v-model="filterState.user_group"
            :options="roleName"
            :clearable="false"
            label="role_code"
            placeholder="กรุณาเลือกกลุ่มผู้ใช้งาน"
            :appendToBody="true"
          >
            <template #option="{ role_code }">
              <span class="uppercase">{{role_code}}</span>
            </template>
            <template #selected-option="{ role_code }">
              <span class="uppercase">{{role_code}}</span>
            </template>
            <template #no-options="">
              <p class="text-sm font-normal text-gray-500">
                ไม่พบข้อมูล
              </p>
            </template>
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
            </template>
          </v-select>
        </div>
      </section>
      <UsersSection
        :organize="filterState.organize"
        :sub_organize="filterState.sub_organize"
        :province="filterState.province"
        @update:organize="filterState.organize=$event"
        @update:sub_organize="filterState.sub_organize=$event"
        @update:province="filterState.province=$event"
      />
      <section data-test="filter-username-section">
        <div class="mt-2">
          <label class="from-label text-xxs text-gray-600" for="osm-select">ชื่อผู้ใช้งาน</label>
          <input type="text" class="form-control" placeholder="กรุณากรอกชื่อผู้ใช้งาน (username)" v-model="filterState.username" />
        </div>
      </section>
        <div class="flex justify-end mt-3">
            <button class="btn btn-outline-secondary mr-2" @click="resetState">
                ล้าง
            </button>
            <button class="btn btn-primary" @click="sendToStore">
                ค้นหา
            </button>
        </div>
    </FilterLayout>
</template>
<script setup>
import FilterLayout from "./layout/index.vue"
import { reactive, onMounted,} from "vue";
import { useStore } from "vuex";
import UsersSection from "./component/UsersSection.vue"
import roleName from "@/data/roles_name.json"

const INIT_FILTER_VALUE = {
  user_group: {
    "role_code": "cm",
    "position_name": "เจ้าหน้าที่พัฒนาสังคมและความมั่นคงของมนุษย์",
    "position_name_short": "เจ้าหน้าที่ พม."
  },
  organize: null,
  sub_organize: null,
  province: null,
  username: null,
};

const store = useStore();
const filterState = reactive({ ...INIT_FILTER_VALUE });

onMounted(() => {
  Object.assign(
    filterState,
    JSON.parse(JSON.stringify(store.getters["usersFilter/getAllFilter"]))
  );
});


const resetState = () => {
  const initFilter = JSON.parse(JSON.stringify(INIT_FILTER_VALUE))
  Object.assign(filterState, initFilter);
};
const sendToStore = () => {
  store.dispatch(
    "usersFilter/setStore",
    JSON.parse(JSON.stringify(filterState))
  );
};


</script>